<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icontiku1"></i>
      基础知识
    </div>
    <div class="padding-sm">
      <div class="flex flex-direction align-start margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-select v-model="subject_first_id" filterable clearable placeholder="请选择科目"
                     style="width: 100%">
            <el-option v-for="item in subjectFirsts" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <el-select class="margin-left-sm" v-model="question_type_id" filterable clearable placeholder="请选择类别"
                     style="width: 100%">
            <el-option v-for="item in subjectTypes" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <el-button class="margin-left-sm" type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <div class="flex align-center condition-warpper margin-top-sm">
          <el-button type="primary" @click="subdialogDialog = true">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>新增
            </p>
          </el-button>
          <el-upload
              class="margin-lr-xs"
              :action="actiocn"
              :name="'file'"
              :data="requestData"
              :before-upload="beforeAvatarUpload"
              :on-progress="uploadVideoProcess"
              :on-success="handleSuccess"
              :limit="1"
          >
            <el-button type="primary">
              <p class="flex align-center font-size">
                <i class="iconfont iconxinzeng margin-right-xs"></i>导入
              </p>
            </el-button>
          </el-upload>

          <el-button type="primary" @click="exportBasics">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>导出
            </p>
          </el-button>
          <el-button type="primary" @click="downModel()">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>下载模版
            </p>
          </el-button>
        </div>
      </div>
      <div class="table-warpper">
        <el-table
            :data="examBaseList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="ID">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="科目">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.subject_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="题目类型">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.question_type_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单选题量">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.dan }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="多选题量">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.duo }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="判断题量">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.pan }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row)"
                >试题列表
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="examBaseList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <subdialog-dialog
        :setId="setId"
        :setItem="setItem"
        :subdialogDialog="subdialogDialog"
        @cancelDialog="cancelDialog"
    />

  </div>
</template>

<script>
import {examBaseGroupList, examSubject, questionTypeList, downloadBase, exportBase} from "@/api/projectOffice";
import subdialogDialog from "@/views/projectOffice/page/dialog/basicsDialog";
import {UPFILE} from "@/config";

export default {
  name: "basics",
  data() {
    return {
      subject_first_id: '',
      subjectSeconds: [],
      question_type_id: '',
      subjectTypes: [],
      examBaseList: [],
      subjectFirsts: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      setItem: {},
      actiocn: UPFILE + '/admin/importBase',
      requestData: {
        u_token: this.$store.state.token2
      },
      subdialogDialog: false
    };
  },
  components: {
    subdialogDialog
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：题库管理 > 基础知识",
        false
    );
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
      this.subject_first_id = this.$route.query.subject_first_id?Number(this.$route.query.subject_first_id):''
      this.question_type_id = this.$route.query.question_type_id?Number(this.$route.query.question_type_id):''
    }
    this.init()
    this.getList();
  },
  methods: {
    beforeAvatarUpload (file) {
      const isTypeTrue = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'|| file.type === 'application/vnd.ms-excel';
      if (!isTypeTrue) {
        this.$message.error('只能上传Excel文件');
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    //  上传中
    uploadVideoProcess (event, file) {
      this.loading.text = '已上传' + file.percentage.toFixed(0) + '%'
    },
    handleSuccess(file) {
      this.loading.close();
      if (file.code === 0) {
        this.$message.success('导入成功')
        this.$router.go(-1)
      } else {
        this.$message.error(file.msg)
      }
    },
    //  获取科目/试题类型
    async init() {
      let _first = await examSubject(
          1,
          10000,
          1,
          1
      );
      this.subjectFirsts = [...[{name:'全部科目',id:''}],..._first.data.list];
      let _type = await questionTypeList(1);
      this.subjectTypes =[...[{name:'全部类别',id:''}],..._type.data];
    },
    //  获取列表
    async getList() {
      let _list = await examBaseGroupList(
          this.subject_first_id,
          this.question_type_id,
          this.page,
          this.limit);
      this.examBaseList = _list.data.list;
      this.total = _list.data.count;
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/projectOffice/basics',
        query: {
          page: this.page,
          question_type_id: this.question_type_id,
          subject_first_id: this.subject_first_id,
        }
      })
    },
    onSearch() {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
    editItem(obj) {
      this.$router.push('/projectOffice/basicsExam?subject=' + obj.subject_first_id + '&type=' + obj.question_type_id)
    },
    async downModel(path = '', name = '题库模版') {
      let _data = await downloadBase(path)
      let blob = _data.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', name + '.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    async exportBasics() {
      let _data = await exportBase(this.subject_first_id,
          this.question_type_id,)
      this.downModel(_data.data.file_path, '题库')
    },
    cancelDialog(val) {
      this.init()
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
      }
    },
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>